document.addEventListener("DOMContentLoaded", () => {
  // Throttle function to limit the rate of function execution
  function throttle(func, delay) {
    let timeoutId;
    return function (...args) {
      if (timeoutId) {
        return;
      }
      timeoutId = setTimeout(() => {
        func(...args);
        timeoutId = undefined;
      }, delay);
    };
  }

  // Function to position a floating element below a previous element at a distance from the top of the page
  function positionFloatingElement() {
    if (window.screen.width < 769 || window.innerWidth < 769) {
      // get the previous element you want to position the floating element below
      const previousElement = document.querySelector("header.header");

      // calculate the distance of the bottom of the previous element from the top of the page
      const previousDistanceFromTop =
        previousElement.getBoundingClientRect().height; /*+ window.pageYOffset*/

      // get the floating element you want to position
      const floatingElement = document.querySelector(
        ".modal__content.search-modal"
      );

      // set the top position of the floating element to the calculated distance
      floatingElement.style.top = previousDistanceFromTop + "px";
      floatingElement.style.height = previousDistanceFromTop + "px";

      console.log(floatingElement);
    }
  }

  // Throttle the function to run at most once every 100 milliseconds
  const throttledPositionFloatingElement = throttle(
    positionFloatingElement,
    300
  );

  //run the function on load
  positionFloatingElement();
  // Run the function on window resize
  window.addEventListener("resize", throttledPositionFloatingElement);
});
